document.addEventListener("DOMContentLoaded", () => {

  const gallery = document.querySelector('[id^="MediaGallery"]');
  if (!gallery) return;

  // 🔥 esperar a que Shopify termine de renderizar
  setTimeout(() => {

    const thumbnails = gallery.querySelectorAll('.thumbnail');
    const items = gallery.querySelectorAll('.product__media-item');

    function activateMedia(id) {

      // quitar activos
      items.forEach(item => {
        item.classList.remove('is-active');
      });

      // activar el correcto
      const target = gallery.querySelector(`.product__media-item[data-media-id="${id}"]`);
      if (target) {
        target.classList.add('is-active');
      }

      // actualizar miniaturas
      thumbnails.forEach(t => {
        t.classList.toggle('active', t.dataset.mediaId === id);
      });
    }

    // 🔥 FORZAR SIEMPRE LA PRIMERA IMAGEN
    if (items.length > 0) {
      const firstId = items[0].dataset.mediaId;
      activateMedia(firstId);
    }

    // eventos en miniaturas
    thumbnails.forEach((thumb) => {
      thumb.addEventListener('click', function () {
        activateMedia(this.dataset.mediaId);
      });
    });

  }, 250); // 🔥 delay clave

});